import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsCheckList, goodscheckCreate, deleteGoodscheck, goodsCheckUpdate, goodsCheckSubmit, goodsCheckFind, goodsCheck, goodsCheckDownload } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from "vuex";

var _this;

export default {
  name: 'BianlidianCheck',
  components: {
    SearchTerm: SearchTerm
  },
  computed: _objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])),
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd');
      } else {
        return '';
      }
    },
    formatDateTime: function formatDateTime(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGoodsCheckList,
      type: '',
      searchInfo: {
        // 按配置顺序显示
        'sellerId': '',
        'auditStatus': ''
      },
      multipleSelection: [],
      viewAndAuditdialogVisible: false,
      addDialogVisible: false,
      qrcodeDialogVisible: false,
      qrcodeText: '',
      loading: false,
      loadingText: '',
      bairunLogo: require('@/assets/bairun-logo.jpg'),
      goodsCheckDetailTableData: [],
      checkPageInfo: {
        page: 1,
        total: 10,
        pageSize: 20
      },
      checkSearchInfo: {
        goodsNo: '',
        goodsName: '',
        isDifference: '',
        isChecked: ''
      },
      formData: {
        sellerId: '',
        sellerName: '',
        checkNo: '',
        checkName: '',
        differenceRemark: '',
        auditStatus: '',
        auditRemark: '',
        CreatedAt: ''
      },
      addRules: {
        sellerId: [{
          required: true,
          message: '请选择便利店',
          trigger: 'blur'
        }],
        checkName: [{
          required: true,
          message: '请输入计划名称',
          trigger: 'blur'
        }]
      },
      submitRules: {
        differenceRemark: [{
          required: true,
          message: '请输入盈亏说明',
          trigger: 'blur'
        }]
      },
      auditRules: {
        auditRemark: [{
          required: true,
          message: '请输入审核意见',
          trigger: 'blur'
        }],
        auditStatus: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.getTableData();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSearch: function onSearch() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.page = 1;
                _this3.pageSize = 10;
                _this3.loading = true;

                _this3.getTableData();

                _this3.loading = false;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onCheckSubmit: function onCheckSubmit() {
      this.checkPageInfo.page = 1;
      this.handelView(this.formData);
    },
    onCheckReset: function onCheckReset() {
      this.checkSearchInfo = {};
      this.onCheckSubmit();
    },
    onSetPageCheck: function onSetPageCheck() {
      var that = this;
      that.$confirm('确定把本页全部设置为已盘吗？', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(function () {
        that.goodsCheckDetailTableData.forEach(function (item) {
          item.isChecked = 1;
        });
        that.handelUpdate(false);
      }).catch(function () {});
    },
    handleCheckDialogSizeChange: function handleCheckDialogSizeChange(val) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.checkPageInfo.pageSize = val;

                _this4.handelView(_this4.formData);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handleCheckDialogCurrentChange: function handleCheckDialogCurrentChange(val) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this5.checkPageInfo.page = val;

                _this5.handelView(_this5.formData);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 输入盘点数
    onInputCheckNum: function onInputCheckNum(row) {
      console.log('onInputCheckNum');

      if (!isNaN(row.checkNum)) {
        row.differenceNum = parseInt(row.checkNum) - parseInt(row.goodsStock);
      }

      if (!isNaN(row.goodsLatestCost) && !isNaN(row.differenceNum)) {
        row.differenceAmount = (parseFloat(row.goodsLatestCost) * parseFloat(row.differenceNum)).toFixed(2);
      }
    },
    handleMoreCommand: function handleMoreCommand(command) {
      debugger;

      switch (command.triggle) {
        case 'onUpdate':
          this.onUpdate(command.params);
          break;

        case 'onSubmitAudit':
          this.onSubmitAudit(command.params);
          break;

        case 'onDelete':
          this.onDelete(command.params);
          break;

        default:
          break;
      }
    },
    // 新增盘点
    onAdd: function onAdd() {
      var that = this;
      that.addDialogVisible = true;
      that.type = 'add';
    },
    // 查看二维码
    onViewQrcode: function onViewQrcode(row) {
      debugger;
      this.qrcodeDialogVisible = true;
      this.qrcodeText = row.qrcode;
      this.formData.checkName = row.checkName;
      this.formData.sellerName = this.allStationMap[String(row.sellerId)].stationName;
      this.formData.CreatedAt = this.$options.filters.formatDateTime(row.CreatedAt);
    },
    handelView: function handelView(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, param, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this6;
                that.checkSearchInfo.checkNo = row.checkNo;
                that.checkSearchInfo.sellerId = row.sellerId;
                param = Object.assign(that.checkSearchInfo, that.checkPageInfo);
                _context7.next = 6;
                return goodsCheckFind(param);

              case 6:
                res = _context7.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  that.goodsCheckDetailTableData = res.data.list;
                }

                that.viewAndAuditdialogVisible = true;
                that.formData = row;
                debugger;
                that.formData.auditStatus = parseInt(that.formData.auditStatus);
                that.checkPageInfo.total = res.data.total;
                that.checkPageInfo.page = res.data.page;

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 变更
    onUpdate: function onUpdate(row) {
      debugger;
      this.handelView(JSON.parse(JSON.stringify(row)));
      this.type = 'update';
    },
    // 查看
    onView: function onView(row) {
      var that = this;

      if (!row && that.multipleSelection.length === 0) {
        that.$message({
          type: 'warning',
          message: '请选择要操作的数据'
        });
        return;
      }

      that.handelView(JSON.parse(JSON.stringify(row || that.multipleSelection[0])));
      this.type = 'view';
    },
    // 提审
    onSubmitAudit: function onSubmitAudit(row) {
      debugger;
      this.handelView(JSON.parse(JSON.stringify(row)));
      this.type = 'submit';
    },
    // 审核
    onAudit: function onAudit(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                debugger;
                _context8.next = 3;
                return _this7.handelView(JSON.parse(JSON.stringify(row)));

              case 3:
                _this7.type = 'audit';
                _this7.formData.auditStatus = '';

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 导出
    onExport: function onExport(row) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return goodsCheckDownload({
                  'sellerId': row.sellerId,
                  'checkNo': row.checkNo
                });

              case 2:
                res = _context9.sent;

                if (res.code === 0) {
                  window.open(res.data.fileUrl);
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteGoodscheck({
          'sellerId': row.sellerId,
          'checkNo': row.checkNo
        }).then(function (res) {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.getTableData();
          } // eslint-disable-next-line handle-callback-err

        }, function (err) {});
      }).catch(function (err) {});
    },
    closeDialog: function closeDialog() {
      this.addDialogVisible = false;
      this.viewAndAuditdialogVisible = false;
      this.goodsCheckDetailTableData = [];
      this.type = '';
      this.qrcodeDialogVisible = false;
      this.qrcodeText = '';
      this.loading = false;
      this.loadingText = '';
      this.checkSearchInfo = {
        goodsNo: '',
        goodsName: '',
        isDifference: '',
        isChecked: ''
      };
      this.checkPageInfo = {
        page: 1,
        total: 10,
        pageSize: 20
      };
      this.formData = {
        sellerId: '',
        sellerName: '',
        checkNo: '',
        checkName: '',
        differenceRemark: '',
        auditStatus: '',
        auditRemark: '',
        CreatedAt: ''
      };
    },
    onDialogSubmit: function onDialogSubmit() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var that;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                that = _this8;

                if (!_this8.loading) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt("return");

              case 3:
                _this8.loading = true;
                _this8.loadingText = '加载中...';
                _context10.t0 = that.type;
                _context10.next = _context10.t0 === 'add' ? 8 : _context10.t0 === 'update' ? 10 : _context10.t0 === 'submit' ? 12 : _context10.t0 === 'audit' ? 14 : _context10.t0 === 'view' ? 16 : 18;
                break;

              case 8:
                that.handelAdd();
                return _context10.abrupt("break", 19);

              case 10:
                that.handelUpdate(true);
                return _context10.abrupt("break", 19);

              case 12:
                that.handelSubmit();
                return _context10.abrupt("break", 19);

              case 14:
                that.handelAudit();
                return _context10.abrupt("break", 19);

              case 16:
                that.closeDialog();
                return _context10.abrupt("break", 19);

              case 18:
                return _context10.abrupt("break", 19);

              case 19:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: res.msg
        });
        this.closeDialog();
        this.getTableData();
      } else {
        this.loading = false;
        this.loadingText = '';
      }
    },
    // 新增保存
    handelAdd: function handelAdd() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this9;
                debugger;
                that.$refs['formData'].validate(function (valid) {
                  if (!valid) {
                    that.loading = false;
                    that.loadingText = '';
                  }

                  if (valid) {
                    goodscheckCreate({
                      'sellerId': parseInt(that.formData.sellerId),
                      'checkName': that.formData.checkName
                    }).then(function (res) {
                      that.enterDialogRepose(res);
                    }, function (error) {
                      that.loading = false;
                      that.loadingText = '';
                    });
                  }
                });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    // 变更保存
    handelUpdate: function handelUpdate(isClose) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var that;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                that = _this10;
                debugger;
                goodsCheckUpdate({
                  'sellerId': parseInt(that.formData.sellerId),
                  'checkNo': that.formData.checkNo,
                  'checkName': that.formData.checkName,
                  'list': that.goodsCheckDetailTableData
                }).then(function (res) {
                  isClose && that.enterDialogRepose(res);
                }, function (error) {
                  that.loading = false;
                  that.loadingText = '';
                });

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    // 单个变更保存
    handleSingleUpdate: function handleSingleUpdate(row) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var that;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                that = _this11;
                debugger;

                if (row.checkNum > 0) {
                  row.isChecked = 1;
                }

                goodsCheckUpdate({
                  'sellerId': parseInt(that.formData.sellerId),
                  'checkNo': that.formData.checkNo,
                  'checkName': that.formData.checkName,
                  'list': [row]
                }).then(function (res) {}, function (error) {});

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    // 提交保存
    handelSubmit: function handelSubmit() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var that;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                that = _this12;
                debugger;
                that.$refs['submitForm'].validate(function (valid) {
                  if (!valid) {
                    that.loading = false;
                    that.loadingText = '';
                  }

                  if (valid) {
                    goodsCheckSubmit({
                      'sellerId': that.formData.sellerId,
                      'checkNo': that.formData.checkNo,
                      'differenceRemark': that.formData.differenceRemark
                    }).then(function (res) {
                      that.enterDialogRepose(res);
                    }, function (error) {
                      that.loading = false;
                      that.loadingText = '';
                    });
                  }
                });

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },
    // 审核保存
    handelAudit: function handelAudit() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var that;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                that = _this13;
                debugger;
                that.$refs['auditForm'].validate(function (valid) {
                  if (!valid) {
                    that.loading = false;
                    that.loadingText = '';
                  }

                  if (valid) {
                    goodsCheck({
                      'sellerId': that.formData.sellerId,
                      'checkNo': that.formData.checkNo,
                      'auditStatus': parseInt(that.formData.auditStatus),
                      'auditRemark': that.formData.auditRemark
                    }).then(function (res) {
                      that.enterDialogRepose(res);
                    }, function (error) {
                      that.loading = false;
                      that.loadingText = '';
                    });
                  }
                });

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    }
  }
};